import { createSelector } from 'reselect'

const getPlayers = state => state.misc.players

const getPlayersOnBackSide = createSelector(
  [ getPlayers ],
  ( players ) => {
    return [ ...Array(10) ].map( (_, pos) => {
      const player = players.find( p => p.front9 === false && p.position === pos)
      return player === undefined ? { id: `${pos}`, empty: true, position: pos, front9: false } : { ...player, empty: false }
    })
  },
)

export default getPlayersOnBackSide
